const EASTER_EGG_IDS = {
	COMING_UNGLUED: 'coming-unglued',
	AIR_HOCKEY_COIN: 'air-hockey-coin',
	CATCH_ME_IF_YOU_CAN: 'catch-me-if-you-can',
	CONFETTI_PARTY: 'confetti-party',
	LASER_CAT: 'laser-cat',
	LAWYER_JARGON: 'lawyer-jargon',
	LLAMA_TIME: 'llama-time',
	EASTER_EGG_BADGE: 'easter-egg-badge',
};

export default EASTER_EGG_IDS;
